import { css } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { SCREENS } from '@cloudsuite/mosaic-shared/styles/breakpoints.js'


export const style = css`
  :host {
    display: block;
  }

  

  .row {
    display: grid;
    grid-template-columns: 1fr auto auto;
    gap: ${csSpacing.spacing06};
    align-items: flex-start;
  }

  cse-text-input {
    width: 100%;
  }

  .quantity-input {
    width: 80px;
  }

  .product-code-input-container {
    position: relative;
    width: 100%;
  }

  .search-indicator {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
  }

  .product-info-container {
    display: flex;
    flex-direction: row;
    gap: ${csSpacing.spacing06};
    justify-content: space-between;

    
    @media(max-width: ${SCREENS.small}) {
      flex-direction: column;
      gap: ${csSpacing.spacing04};
    }
  }
  
  .product-info,
  .product-price {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing02};
    
  }
  .product-info {
    flex :1;
  }
  .product-price {
    align-items: flex-end;
  }
  
  .product-price {
    @media(max-width: ${SCREENS.medium}) {
      flex-direction: row;
      gap: ${csSpacing.spacing05};
      align-items: center;
    }
  }
`
